import { post } from './utils';

export const subscribeUnsubscribeMarketingList = async params =>
  post('/custom-action/subscribe-unsubscribe-marketing-list', params);

export const marketingList = { subscribeUnsubscribeMarketingList };
